export default __webpack_public_path__ + "static/media/xwin-Team-PhotosCalvin.2c523b34.png";